import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxButtonModule,
    DxDateBoxModule,
    DxFormModule,
    DxLoadPanelModule,
    DxRadioGroupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidationGroupModule,
    DxValidatorModule,
} from 'devextreme-angular';
import { IncidentReportDto, IncidentStepDto } from '@services';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
import { ScrollSectionViewComponent } from '../scroll-section-view.component';

@Component({
    selector: 'app-events-sequence-section',
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxValidationGroupModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        DxScrollViewModule,
        DxFormModule,
        DxRadioGroupModule,
        DxTextAreaModule,
        DxCheckBoxModule,
    ],
    templateUrl: './events-sequence-section.component.html',
})
export class EventsSequenceSectionComponent extends ScrollSectionViewComponent {
    @Input() incidentReport: IncidentReportDto;
    @Input() isReadOnly: boolean = false;

    addStep() {
        const nextNumber = this.incidentReport.steps.length;
        this.incidentReport.steps.push(
            IncidentStepDto.fromJS({ description: '', stepNumber: nextNumber }),
        );

        setTimeout(() => {
            this.scrollToSection('sequenceOfEventsSection');
        });
    }

    removeStep(index: number) {
        this.incidentReport.steps.splice(index, 1);

        this.incidentReport.steps.forEach((step, i) => {
            step.stepNumber = i;
        });
    }
}
